import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9D9D9",
      d: "M19.416.657a2 2 0 0 1 2.14.041L38.23 11.715c1.893 1.25.571 4.187-1.62 3.6l-15.615-4.182a2 2 0 0 0-.995-.01l-17.326 4.26C.45 15.93-.798 12.92 1.159 11.731z"
    }, null, -1)
  ])))
}
export default { render: render }